import { tokenAmountFromProxy, tokenAmountToProxy } from "./tokenAmount";
export function ergoBoxCandidateFromProxy(proxy) {
    return {
        ...proxy,
        value: BigInt(proxy.value),
        assets: proxy.assets.map(a => tokenAmountFromProxy(a))
    };
}
export function ergoBoxCandidateToProxy(box) {
    return {
        ...box,
        value: box.value.toString(),
        assets: box.assets.map(a => tokenAmountToProxy(a))
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXJnb0JveENhbmRpZGF0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9lbnRpdGllcy9lcmdvQm94Q2FuZGlkYXRlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBYyxvQkFBb0IsRUFBb0Isa0JBQWtCLEVBQUMsTUFBTSxlQUFlLENBQUE7QUFvQnJHLE1BQU0sVUFBVSx5QkFBeUIsQ0FBQyxLQUE0QjtJQUNwRSxPQUFPO1FBQ0wsR0FBRyxLQUFLO1FBQ1IsS0FBSyxFQUFFLE1BQU0sQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDO1FBQzFCLE1BQU0sRUFBRSxLQUFLLENBQUMsTUFBTSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLG9CQUFvQixDQUFDLENBQUMsQ0FBQyxDQUFDO0tBQ3ZELENBQUE7QUFDSCxDQUFDO0FBRUQsTUFBTSxVQUFVLHVCQUF1QixDQUFDLEdBQXFCO0lBQzNELE9BQU87UUFDTCxHQUFHLEdBQUc7UUFDTixLQUFLLEVBQUUsR0FBRyxDQUFDLEtBQUssQ0FBQyxRQUFRLEVBQUU7UUFDM0IsTUFBTSxFQUFFLEdBQUcsQ0FBQyxNQUFNLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsa0JBQWtCLENBQUMsQ0FBQyxDQUFDLENBQUM7S0FDbkQsQ0FBQTtBQUNILENBQUMifQ==